import { AuthGuard } from './../../common/guards/auth.guard';
import { Routes } from '@angular/router';
import { GrantsComponent } from './grants/grants.component';
import { GrantComponent } from './grant/grant.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationComponent } from './notification/notification.component';
import { RoleGuard } from '../../common/guards/role.guard';
import { Roles } from '../../common/models/roles';
import { AssociationsComponent } from './associations/associations.component';
import { ReviewComponent } from './review/review.component';
import { ApplicationsComponent } from './applications/applications.component';
import { AllocationsComponent } from './allocations/allocations.component';
import { AssociationComponent } from './association/association.component';
import { ApplicationComponent } from './application/application.component';
import { AllocationComponent } from './allocation/allocation.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { ProjectsComponent } from './projects/list/projects.component';
import { ReportsComponent } from './projects/reports/list/reports.component';
import { DescriptionComponent } from './projects/reports/description/description.component';
import { ExpenditureComponent } from './projects/reports/expenditure/expenditure.component';
import { ProjectComponent } from './projects/project/edit/project.component';
import { ContractsComponent } from './projects/project/contracts/list/contracts.component';
import { ContractComponent } from './projects/project/contracts/edit/contract.component';
import { ProjectBudgetsComponent } from './projects/project/budgets/list/budgets.component';
import { ProjectBudgetComponent } from './projects/project/budgets/view/budget.component';
import { ComplyComponent } from './complies/edit/comply.component';
import { FilterScopeResolver } from '../../common/components/filter/resolver/filter-scope.resolver';
import { RefundComponent } from './projects/project/refunds/edit/refund.component';
import { RefundsComponent } from './projects/project/refunds/list/refunds.component';
import { RefundViewComponent } from './projects/project/refunds/view/refund-view.component';
import { SaldoComponent } from './projects/project/saldo/saldo.component';
import { AssociationViewComponent } from './association/view/association-view.component';


export const municipalityRoutes: Routes = [
      {
        path: 'municipality',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [Roles.MunicipalityAdministrator] },
        resolve: { setScope: FilterScopeResolver },
        runGuardsAndResolvers: 'always',
        children: [
          { path: 'associations', component: AssociationsComponent },
          { path: 'associations/create', component: AssociationComponent },
          { path: 'associations/:id/view', component: AssociationViewComponent },
          { path: 'associations/:id/edit', component: AssociationComponent },
          { path: 'grants', component: GrantsComponent },
          { path: 'grants/create', component: GrantComponent },
          { path: 'grants/:id/edit', component: GrantComponent },
          { path: 'notifications', component: NotificationsComponent },
          { path: 'notifications/create', component: NotificationComponent },
          { path: 'applications', component: ApplicationsComponent },
          { path: 'applications/:applicationId/view', component: ApplicationComponent},
          { path: 'applications/:applicationId/comply', component: ComplyComponent },
          { path: 'applications/:applicationId/review', component: ReviewComponent },
          { path: 'applications/:applicationId/reviews', component: ReviewsComponent },
          { path: 'allocations', component: AllocationsComponent },
          { path: 'allocations/:allocationId/view', component: AllocationComponent},
          { path: 'projects', component: ProjectsComponent },
          { path: 'projects/:submissionId/create', component: ProjectComponent },
          { path: 'projects/:projectId/edit', component: ProjectComponent },
          { path: 'projects/:projectId/budgets', component: ProjectBudgetsComponent },
          { path: 'projects/:projectId/budgets/:projectBudgetId/view', component: ProjectBudgetComponent },
          { path: 'projects/:projectId/saldo', component: SaldoComponent },
          { path: 'projects/:projectId/contracts', component: ContractsComponent },
          { path: 'projects/:projectId/contracts/create', component: ContractComponent },
          { path: 'projects/:projectId/contracts/:contractId/edit', component: ContractComponent },
          { path: 'projects/:projectId/refunds', component: RefundsComponent },
          { path: 'projects/:projectId/refunds/create', component: RefundComponent },
          { path: 'projects/:projectId/refunds/:refundId/view', component: RefundViewComponent },
          { path: 'projects/:projectId/refunds/:refundId/edit', component: RefundComponent},
          { path: 'projects/:projectId/reports', component: ReportsComponent },
          { path: 'projects/:projectId/reports/:reportId/description/view',  component: DescriptionComponent },
          { path: 'projects/:projectId/reports/:reportId/expenditure/view',  component: ExpenditureComponent }
        ]
      }

]
